import { c as _c } from "react/compiler-runtime";
import LinkComponent, { LinkComponentLink } from '../link/link.component';
import { ReactElement, memo, useId } from 'react';
import ConfigurableCmsComponentMetadata from '../../top-level-components/cms-page/metadata/configurable/configurable-cms-component-metadata.component';
import ConfigurableCmsSlotMetadata from '../../top-level-components/cms-page/metadata/configurable/configurable-cms-slot-metadata.component';
import ImageComponent from '@spa/components/image-component/image.component';
import { Metadata } from '@spa/top-level-components/cms-page/metadata/Metadata';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import getAuthSessionUserId from '../../lib/auth/getAuthSessionUserId';
import selectWishlistSettings from '@spa/lib/store/settings/selectors/selectWishlistSettings';
import styles from './icon-list.component.module.scss';
import { tracker } from '@spa/lib/tracking/tracker';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import useNextAuthOrSession from '../../lib/react/hooks/useNextAuthOrSession';
import { useSelector } from 'react-redux';
interface Icon {
  readonly src: string;
  readonly alt: string;
  readonly width: number;
  readonly height: number;
  readonly mimeType: string;
}
export interface IconListIcon {
  readonly icon: Icon;
  readonly link: LinkComponentLink;
  readonly text: string;
  readonly metadata: ReadonlyArray<Metadata>;
}
export interface Props {
  readonly cartTotalQuantityCount: number;
  readonly editorMode: boolean;
  readonly icons: ReadonlyArray<IconListIcon>;
  readonly iconsMetadata: ReadonlyArray<Metadata>;
  readonly wishlistTotalQuantityCount: number;
}
const isCartIcon = (link: LinkComponentLink): boolean => 'path' in link && link.path?.includes('cart');
const isWishlistIcon = (link: LinkComponentLink): boolean => 'path' in link && link.path?.includes('wishlists');
const isBrochureIcon = (link: LinkComponentLink): boolean => 'path' in link && link.path.includes('brochure');
const isMyAccountIcon = (link: LinkComponentLink): boolean => 'path' in link && link.path.endsWith('my-account/');
function IconListComponent(t0) {
  const $ = _c(41);
  const {
    cartTotalQuantityCount,
    editorMode,
    icons,
    iconsMetadata,
    wishlistTotalQuantityCount
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("icon-list");
  const {
    authSession
  } = useNextAuthOrSession();
  let t1;
  if ($[0] !== authSession) {
    t1 = getAuthSessionUserId(authSession);
    $[0] = authSession;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const userId = t1;
  const hasProductsInCart = cartTotalQuantityCount > 0;
  const hasProductsInWishlists = wishlistTotalQuantityCount > 0;
  const {
    myAccountEnabled: isWishlistEnabled
  } = useSelector(selectWishlistSettings);
  const iconListId = useId();
  const iconListItemClasses = _temp;
  let t2;
  if ($[2] !== hasProductsInCart || $[3] !== hasProductsInWishlists) {
    t2 = link_0 => classNames(styles["icon-list__icon"], {
      [styles["icon-list__cart-icon"]]: isCartIcon(link_0),
      [styles["icon-list__cart-icon--with-products"]]: isCartIcon(link_0) && hasProductsInCart,
      [styles["icon-list__wishlist-icon--with-products"]]: isWishlistIcon(link_0) && hasProductsInWishlists
    });
    $[2] = hasProductsInCart;
    $[3] = hasProductsInWishlists;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const iconClasses = t2;
  const infoBubble = _temp2;
  let t3;
  if ($[5] !== editorMode || $[6] !== iconsMetadata) {
    t3 = editorMode && <ConfigurableCmsSlotMetadata beforeSlot={true} metadata={iconsMetadata} />;
    $[5] = editorMode;
    $[6] = iconsMetadata;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== formatMessage) {
    t4 = formatMessage("iconListNavigation");
    $[8] = formatMessage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== cartTotalQuantityCount || $[11] !== editorMode || $[12] !== hasProductsInCart || $[13] !== hasProductsInWishlists || $[14] !== iconClasses || $[15] !== iconListId || $[16] !== icons || $[17] !== isWishlistEnabled || $[18] !== userId || $[19] !== wishlistTotalQuantityCount) {
    let t6;
    if ($[21] !== cartTotalQuantityCount || $[22] !== editorMode || $[23] !== hasProductsInCart || $[24] !== hasProductsInWishlists || $[25] !== iconClasses || $[26] !== iconListId || $[27] !== isWishlistEnabled || $[28] !== userId || $[29] !== wishlistTotalQuantityCount) {
      t6 = (t7, index) => {
        const {
          icon: t8,
          link: link_1,
          text,
          metadata
        } = t7;
        const {
          src,
          alt,
          width,
          height,
          mimeType
        } = t8;
        const shouldUseSolidMyAccountIcon = userId !== null && isMyAccountIcon(link_1);
        const isWishlist = isWishlistIcon(link_1);
        const shouldRenderWishlist = !isWishlist || isWishlistEnabled;
        const linkTextId = `${iconListId}-item-${index}-text`;
        return shouldRenderWishlist && <li key={src}><div className={styles["icon-list__item-metadata"]}>{editorMode && <ConfigurableCmsComponentMetadata beforeComponent={true} metadata={metadata} />}</div><LinkComponent link={link_1} ariaLabelledBy={linkTextId} visibleText={text} onClick={event => {
            tracker.navigationClick({
              click_name: text,
              click_position: "icon_navi",
              click_url: event.currentTarget.href
            });
          }}><div className={iconListItemClasses(link_1)}><div className={styles["icon-list__icon-wrapper"]}><ImageComponent className={iconClasses(link_1)} src={shouldUseSolidMyAccountIcon ? "/assets/icons/account-solid-icon.svg" : src} alt={`${alt} icon`} width={width} height={height} mimeType={mimeType} />{isCartIcon(link_1) && hasProductsInCart && infoBubble(cartTotalQuantityCount)}{isWishlist && hasProductsInWishlists && infoBubble(wishlistTotalQuantityCount)}</div><span id={linkTextId} className={`${styles["icon-list__text"]} text-xs`}>{text}</span></div></LinkComponent>{editorMode && <ConfigurableCmsComponentMetadata beforeComponent={false} metadata={metadata} />}</li>;
      };
      $[21] = cartTotalQuantityCount;
      $[22] = editorMode;
      $[23] = hasProductsInCart;
      $[24] = hasProductsInWishlists;
      $[25] = iconClasses;
      $[26] = iconListId;
      $[27] = isWishlistEnabled;
      $[28] = userId;
      $[29] = wishlistTotalQuantityCount;
      $[30] = t6;
    } else {
      t6 = $[30];
    }
    t5 = icons.map(t6);
    $[10] = cartTotalQuantityCount;
    $[11] = editorMode;
    $[12] = hasProductsInCart;
    $[13] = hasProductsInWishlists;
    $[14] = iconClasses;
    $[15] = iconListId;
    $[16] = icons;
    $[17] = isWishlistEnabled;
    $[18] = userId;
    $[19] = wishlistTotalQuantityCount;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[31] !== t4 || $[32] !== t5) {
    t6 = <div><ul className={styles["icon-list"]} aria-label={t4}>{t5}</ul></div>;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  let t7;
  if ($[34] !== editorMode || $[35] !== iconsMetadata) {
    t7 = editorMode && <ConfigurableCmsSlotMetadata beforeSlot={false} metadata={iconsMetadata} />;
    $[34] = editorMode;
    $[35] = iconsMetadata;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  let t8;
  if ($[37] !== t3 || $[38] !== t6 || $[39] !== t7) {
    t8 = <div>{t3}{t6}{t7}</div>;
    $[37] = t3;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
  } else {
    t8 = $[40];
  }
  return t8;
}
function _temp2(quantity) {
  return <div className={classNames([styles["icon-list__info-bubble"], "text-s"])} aria-live="polite">{quantity}</div>;
}
function _temp(link) {
  return classNames(styles["icon-list__item"], {
    [styles["icon-list__brochure"]]: isBrochureIcon(link),
    [styles["icon-list__cart"]]: isCartIcon(link)
  });
}
export default memo(IconListComponent);